import type { ReactNode } from 'react';

export const symbol_signpost: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M450-110v-160H255q-12.44 0-23.72-5T212-288l-71-71q-9-9-9-21t9-21l71-71q8-8 19.28-13 11.28-5 23.72-5h195v-90H190q-12.75 0-21.37-8.63Q160-597.25 160-610v-160q0-12.75 8.63-21.38Q177.25-800 190-800h260v-50q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v50h195q12.44 0 23.72 5T748-782l71 71q9 9 9 21t-9 21l-71 71q-8 8-19.28 13-11.28 5-23.72 5H510v90h260q12.75 0 21.38 8.62Q800-472.75 800-460v160q0 12.75-8.62 21.37Q782.75-270 770-270H510v160q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-97.25 450-110ZM220-640h485l50-50-50-50H220v100Zm35 310h485v-100H255l-50 50 50 50Zm-35-310v-100 100Zm520 310v-100 100Z"
		/>
	</svg>
);
